var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222 5102 c-141 -51 -231 -190 -220 -337 11 -127 -42 -70 1071 -1182 l1022 -1023 -1026 -1027 c-1149 -1150 -1064 -1054 -1064 -1208 0 -60 6 -92 22 -127 30 -66 96 -133 162 -165 47 -24 69 -28 136 -28 154 0 58 -84 1208 1064 l1027 1026 1028 -1026 c1150 -1149 1054 -1065 1207 -1063 99 0 174 33 234 100 63 72 84 126 85 219 2 153 86 57 -1063 1207 l-1026 1028 1026 1028 c1148 1149 1064 1053 1064 1207 0 67 -4 89 -28 136 -32 66 -99 132 -165 162 -35 16 -67 22 -127 22 -154 0 -58 85 -1208 -1064 l-1027 -1026 -1023 1022 c-858 859 -1030 1026 -1072 1044 -70 31 -174 35 -243 11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.ea33988cae4e786200d238fef573a8eb.svg";
export { ForwardRef as ReactComponent };